<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="名称" name="naturalName">
                <a-input v-model:value="searchForm.naturalName" placeholder="请输入名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #naturalNatural="{ record }">
                <div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                    <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.naturalNatural"
                                :showBtn="false" disabled/>
                </div>
            </template>

            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin} from "@/mixins";
import {honor} from "@/api/companyService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "名称", dataIndex: "naturalName", key: "naturalName"},
    {title: "图片", dataIndex: "naturalNatural", key: "naturalNatural",slots: {customRender: "naturalNatural"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    props:{activeValue:String},
    components: {
        AddOrEditModal,
    },
    data() {
        return {
            columns,
            queryParamFixed: {type:"1"},
            listUrl: honor.pageList,
            listKeyField: "id",
            deleteUrl: honor.remove
        }
    },
    watch:{
        activeValue(val){
            if(val == 1){
                this.loadData(1)
            }
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal', {type: "1"});
        },
        onEdit(record) {
            this.getAction({
                url: honor.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

    }
}
</script>

<style scoped>

</style>
